export default __webpack_public_path__ + "images/2724eaabc2fea0228cc5e05228fc7ebb.png";